import getJSONFromFile from '@/_core/util/fileUtility.js';

const Settings = require('@/../_config/_app/appConfiguration.json');
const Mappings = require('@/../_config/_app/navigationMapping.json');
const Configurations = require('@/../_config/_app/navigationConfiguration.json');
const Menu = require('@/../_config/_app/commonMenuMapping.json');
const productItemsList = require('@/../_config/_app/productItems.json');

const appSettings = getJSONFromFile(Settings);
const navigationMapping = getJSONFromFile(Mappings);
const navigationConfiguration = getJSONFromFile(Configurations);
const menuSettings = getJSONFromFile(Menu);
const productItems = getJSONFromFile(productItemsList);

export default appSettings;
export { navigationMapping, navigationConfiguration, menuSettings, productItems };
